import { Controller } from "@hotwired/stimulus"

// 出庫数量をリアルタイム計算するコントローラー
export default class extends Controller {
  static targets = ["cases", "packs", "individuals", "quantity"]
  static values = {
    quantityPerCase: Number,
    quantityPerPack: Number
  }

  connect() {
    this.calculate()
  }

  calculate() {
    const cases = this.hasCasesTarget ? (parseInt(this.casesTarget.value) || 0) : 0
    const packs = this.hasPacksTarget ? (parseInt(this.packsTarget.value) || 0) : 0
    const individuals = this.hasIndividualsTarget ? (parseInt(this.individualsTarget.value) || 0) : 0

    const quantity = (cases * this.quantityPerCaseValue) +
                     (packs * this.quantityPerPackValue) +
                     individuals

    this.quantityTarget.textContent = quantity
  }
}
